import ControlledTooltip from '@atoms/CustomToolTip';
import { Text } from '@components/primitives';
import Info from '@expo/vector-icons/MaterialIcons';
import colors from '@theme/colors';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { SVG_ICONS } from '@utils/SvgIcons';
import { numberWithDots } from '@utils/utils';
import React from 'react';
import { View } from 'react-native';
import poinEarnedStyles from './style';

const e = AMPLITUDE_CONSTANTS.UserProfile;

interface PointEarnedProps {
  accumulatedTotalPoin?: number;
  t: (key: string) => string;
  isPIC: boolean;
}

const PointEarned: React.FC<PointEarnedProps> = ({ accumulatedTotalPoin = 0, t, isPIC }) => (
  <View style={poinEarnedStyles.container}>
    <View style={poinEarnedStyles.infoContainer}>
      <Text variant="md-normal" style={poinEarnedStyles.infoText}>
        {t('userProfile.poinEarned')}
      </Text>
      <ControlledTooltip
        logParams={{
          [e.tooltip_clicked.attributes.source]: 'pic_page',
          [e.tooltip_clicked.attributes.influencer_role]: isPIC ? 'pic' : 'normal_user',
        }}
        translateString={t('userProfile.tooltipBanner')}>
        <Info name="info-outline" color={colors.neutral.darkMist} size={15} />
      </ControlledTooltip>
    </View>

    <View style={poinEarnedStyles.coinContainer}>
      {SVG_ICONS.coin5}
      <Text style={poinEarnedStyles.coinIcon}>{`${numberWithDots(accumulatedTotalPoin)} Poin`}</Text>
    </View>

    <View pointerEvents="none" style={poinEarnedStyles.absoluteContainer}>
      {SVG_ICONS.userProfile.confettiLeft}
      {SVG_ICONS.userProfile.confettiRight}
    </View>
  </View>
);

export default PointEarned;
